import { emptyLocation } from '@features/forms/CaseForms/config';
import { baseCaseSchema, CaseFormType } from '@features/forms/CaseForms/schema';
import {
  validateDateInPast,
  validateDateTimeSelection,
  validateDonorId,
  validateOpoContact,
  validateOpoId,
  validateReallocation,
  validateTxCenterId,
  validateTxCenterAddress,
  validateTxCenterCoordinator,
  validateDonorHospitalId,
  validateDonorOrRequired,
  validateDonorHospitalAddress,
} from '@features/forms/CaseForms/validators';
import { DonorType, Laterality, NRPType, OrganType, ServiceType } from '@/api/apis/case';
import { DEFAULT_TIMEZONE } from '@/constants/timezone';
import { NA_REGION_ID } from '@/constants/serviceRegion.constants';

export const CASE_DEFAULT_VALUES: CaseFormType = {
  serviceType: ServiceType.NopWithTmdxSurgeon,
  donorId: '',
  txCenterId: '',
  txCenterName: '',
  recipientHospitalDate: null,
  recipientHospitalTime: null,
  recipientHospitalTimeZone: DEFAULT_TIMEZONE,
  donorHospitalId: '',
  donorHospitalName: '',
  txCenterCustomLocation: emptyLocation,
  hospitalCustomLocation: emptyLocation,
  donorHospitalDate: null,
  donorHospitalTime: null,
  donorHospitalTimeZone: DEFAULT_TIMEZONE,
  opoId: '',
  opoName: '',
  opoContactId: '',
  opoSourceContactPhone: '',
  secondaryOpoContactId: '',
  secondaryOpoContactPhone: '',
  files: [],
  links: [],
  opoRequest: false,
  originalOpoRequest: false,
  pediatricCase: false,
  reAllocationCase: false,
  isExpeditedCase: false,
  nrp: undefined,
  nrpType: NRPType.aNrp,
  donorType: DonorType.DCD,
  organType: OrganType.Liver,
  laterality: Laterality.NotDefined,
  txCenterTrialPrograms: [],
  serviceRegionId: NA_REGION_ID,
  coordinatorId: '',
  receivingSurgeonId: '',
  isServiceWithoutCoordinator: false,
  isQuestionaryEditAllowed: false,
};

export const caseSchema = baseCaseSchema.superRefine((formData, context) => {
  validateDonorId(formData, context);
  validateReallocation(formData, context);
  // donorHospital
  validateDonorHospitalId(formData, context);
  validateDonorHospitalAddress(formData, context);
  // tx center
  validateTxCenterId(formData, context, 'txCenterId', 'Either TX Center or OPO request should be specified');
  validateTxCenterAddress(formData, context);
  validateTxCenterCoordinator(formData, context);
  validateDateTimeSelection(formData, context, 'recipientHospitalDate', 'recipientHospitalTime');
  validateDateInPast(
    formData,
    context,
    'recipientHospitalDate',
    'recipientHospitalTime',
    'recipientHospitalTimeZone',
    true,
  );
  // opo
  validateOpoId(formData, context);
  validateOpoContact(formData, context);
  // donor OR date time
  validateDonorOrRequired(formData, context);
  validateDateInPast(formData, context, 'donorHospitalDate', 'donorHospitalTime', 'donorHospitalTimeZone');
  validateDateTimeSelection(formData, context, 'donorHospitalDate', 'donorHospitalTime');
});
